import type { IdCompanyDto } from '@/services/ws-companies/src/main/resources/rest-api';

export interface CompanyDetailsRouteParams {
  companyId: IdCompanyDto;
}

export enum CompanyDetailsTab {
  WEBSITES = 'websites',
  ACCOUNTS = 'accounts',
  PROGRAMMATIC_SEATS = 'programmatic-seats',
  EMAIL_SYNC = 'email-sync',
  PERMISSIONS = 'permissions',
  USER_ROLES = 'user-roles',
}
